"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Footer_1 = __importDefault(require("./Footer"));
var MobileFooter_1 = __importDefault(require("./MobileFooter"));
var style_1 = require("./style");
var PRVFooter = /** @class */ (function (_super) {
    __extends(PRVFooter, _super);
    function PRVFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PRVFooter.prototype.render = function () {
        var _a = this.props, className = _a.className, countryCode = _a.countryCode, cultureCode = _a.cultureCode, isLarge = _a.isLarge;
        var locale = cultureCode.toLowerCase() + "-" + countryCode.toUpperCase();
        return (react_1.default.createElement(style_1.Wrapper, { className: className }, ((isLarge)
            ? react_1.default.createElement(Footer_1.default, { locale: locale })
            : react_1.default.createElement(MobileFooter_1.default, { locale: locale }))));
    };
    return PRVFooter;
}(react_1.default.PureComponent));
exports.default = PRVFooter;
__exportStar(require("./types"), exports);
